import google_search from '../../images/Google_search.png';
import data_processing from '../../videos/Search_engine_optimization.mp4';
import data_architecture from '../../videos/data_architecture.mp4';

export const homeObjOne = {
  id: 'googlesearch',
  lightBg: false,
  lightText: true,
  topLine: 'Google Search',
  headline: 'What We Offer in SEO',
  description:
    'There are a number of different elements that determine your Google organic footprint and our job is to understand and act on these for optimal SEO page rankings. Wiry is your go-to destination for top-notch SEO services designed to boost your digital visibility and drive meaningful results. In a world where online competition is fierce, having a strong SEO strategy is crucial to stand out and reach your target audience.',
  buttonLabel: 'Scroll Top',
  imgStart: false,
  img: google_search,
  alt: 'Google search',
  dark: true,
  primary: true,
  darkText: false,
  buttonLink: 'seo-home',
};

export const homeObjTwo = {
  id: 'ourapproach',
  lightBg: true,
  lightText: false,
  topLine: 'SEO',
  headline: 'Our Approach',
  numberedListItems: [
    'Comprehensive SEO Audits',
    'Keyword Optimization',
    'On-Page Optimization',
    'Content Strategy',
    'Link Building',
  ],
  buttonLabel: 'Home',
  imgStart: true,
  video: data_processing,
  alt: 'SEO strategy',
  dark: false,
  primary: false,
  darkText: true,
  buttonLink: 'seo-home',
};

export const homeObjThree = {
  id: 'whychooseus',
  lightBg: true,
  lightText: false,
  topLine: 'Complete Solution',
  headline: 'Why Choose Our Infrastructure',
  listItems: [
    'Proven Results: Our track record speaks for itself.',
    'Transparent Reporting: We believe in keeping you informed.',
    'Continuous Optimization: The digital landscape is ever-evolving, and so are our strategies.',
    'Dedicated Support: Your success is our priority.',
  ],
  buttonLabel: 'Contact Us',
  imgStart: false,
  video: data_architecture,
  alt: 'Infrastructure',
  dark: false,
  primary: false,
  darkText: true,
  buttonLink: 'seo-home',
};
